export default "https://cdn-static.gokick.com/assets/4215e61f258b66d5599ee2c3a2c4c86e46d29fa2/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";